"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrequencyBaseValue = exports.IntervalFrequencyEnum = void 0;

var _FrequencyBaseValue;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IntervalFrequencyEnum;
exports.IntervalFrequencyEnum = IntervalFrequencyEnum;

(function (IntervalFrequencyEnum) {
  IntervalFrequencyEnum["NEVER"] = "never";
  IntervalFrequencyEnum["AS_NEEDED"] = "as-needed";
  IntervalFrequencyEnum["HOUR"] = "hour";
  IntervalFrequencyEnum["DAY"] = "day";
  IntervalFrequencyEnum["TWICE_WEEK"] = "twice-week";
  IntervalFrequencyEnum["WEEK"] = "week";
  IntervalFrequencyEnum["TWICE_MONTH"] = "twice-month";
  IntervalFrequencyEnum["MONTH"] = "month";
  IntervalFrequencyEnum["QUARTER"] = "quarter";
  IntervalFrequencyEnum["TWICE_BIANNUAL"] = "twice-biannual";
  IntervalFrequencyEnum["BIANNUAL"] = "biannual";
  IntervalFrequencyEnum["YEAR"] = "year";
})(IntervalFrequencyEnum || (exports.IntervalFrequencyEnum = IntervalFrequencyEnum = {}));

var FrequencyBaseValue = (_FrequencyBaseValue = {}, _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.NEVER, 0), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.AS_NEEDED, 0), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.HOUR, 8760), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.DAY, 365), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.TWICE_WEEK, 104), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.WEEK, 52), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.TWICE_MONTH, 24), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.MONTH, 12), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.QUARTER, 4), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.TWICE_BIANNUAL, 4), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.BIANNUAL, 2), _defineProperty(_FrequencyBaseValue, IntervalFrequencyEnum.YEAR, 1), _FrequencyBaseValue);
exports.FrequencyBaseValue = FrequencyBaseValue;